var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.0834C17.5029 11.1832 17.2459 12.2683 16.75 13.25C16.162 14.4265 15.2581 15.416 14.1395 16.1078C13.021 16.7995 11.7319 17.1662 10.4167 17.1667C9.31678 17.1696 8.23176 16.9126 7.25 16.4167L2.5 18L4.08333 13.25C3.58744 12.2683 3.33047 11.1832 3.33333 10.0834C3.33384 8.76815 3.70051 7.47907 4.39227 6.36048C5.08402 5.2419 6.07355 4.338 7.25 3.75002C8.23176 3.25413 9.31678 2.99716 10.4167 3.00002H10.8333C12.5703 3.09585 14.2109 3.82899 15.441 5.05907C16.671 6.28915 17.4042 7.92973 17.5 9.66669V10.0834Z",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddComment);
export default __webpack_public_path__ + "static/media/editor_add_comment.49f9abd507d2d1e7297c2cf1e5a777e8.svg";
export { ForwardRef as ReactComponent };